import { Select } from '@doordash/component-fields';
import { InlineChildren } from '@doordash/design-language';
import * as React from 'react';
import { BUDGET_TIMES_SELECT_VALUE_CUSTOM, budgetEndTimes, budgetStartTimes, getTimesForOption, timesSelectOptions, } from '../budget_helper';
import formatTime from '../../../../utils/format_time';
import { InputContainer } from './budget_form_styles';
import { BudgetModalTestId } from '../../../testId';
export var BudgetTimesSelector = function (_a) {
    var values = _a.values, errors = _a.errors, setFieldValue = _a.setFieldValue;
    return (React.createElement(React.Fragment, null,
        React.createElement(InputContainer, { size: "large" },
            React.createElement(Select, { autoComplete: "off", label: "Time employees can order", onChange: function (value) {
                    setFieldValue('budgetTimesSelect', value);
                    setFieldValue('budgetStartTime', getTimesForOption(value).startTime);
                    setFieldValue('budgetEndTime', getTimesForOption(value).endTime);
                }, disabledValue: "Select Time", options: timesSelectOptions.map(function (option) { return ({
                    name: option.label,
                    value: option.value,
                }); }), value: values.budgetTimesSelect, "data-testid": BudgetModalTestId.TimesSelector })),
        Boolean(values.budgetTimesSelect === BUDGET_TIMES_SELECT_VALUE_CUSTOM) ? (React.createElement(InputContainer, { size: "large" },
            React.createElement(InlineChildren, { size: InlineChildren.Sizes.Large },
                React.createElement(Select, { label: "From", onChange: function (value) {
                        setFieldValue('budgetStartTime', value);
                    }, disabledValue: "Select", options: budgetStartTimes.map(function (time) { return ({
                        name: formatTime(time),
                        value: time,
                    }); }), error: errors.budgetStartTime, value: values.budgetStartTime }),
                React.createElement(Select, { label: "To", onChange: function (value) {
                        setFieldValue('budgetEndTime', value);
                    }, disabledValue: "Select", options: budgetEndTimes.map(function (time) { return ({
                        name: formatTime(time),
                        value: time,
                    }); }), error: errors.budgetEndTime, value: values.budgetEndTime })))) : null));
};
export default BudgetTimesSelector;
